import { normalizeInteractionFinalAction } from "../../../types/platformMetrics";
export const predefinedActionTypes = [
    "AgentText",
    "BlindTransfer",
    "Cancel",
    "ControlledTransfer",
    "Disconnect",
    "Email",
    "Error",
    "HandoffTransfer",
    "Hangup",
    "VoiceMessage",
];
export const determineChartGranularity = (startDate, endDate) => {
    if (!startDate || !endDate)
        return "Daily";
    const diffInDays = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
    if (diffInDays <= 7) {
        return "Hourly";
    }
    else if (diffInDays <= 30) {
        return "Daily";
    }
    else {
        return "Weekly";
    }
};
export const generateVolumeChartData = (interactions, chartGranularity, startDate, endDate) => {
    const groupedData = {};
    const actionTypes = predefinedActionTypes;
    if (chartGranularity === "Hourly") {
        const currentDate = new Date(startDate);
        const endDateTime = new Date(endDate);
        while (currentDate <= endDateTime) {
            for (let hour = 0; hour < 24; hour++) {
                const key = `${currentDate.getMonth() + 1}/${currentDate.getDate()} ${String(hour).padStart(2, "0")}:00`;
                if (!groupedData[key]) {
                    groupedData[key] = actionTypes.reduce((acc, action) => ({ ...acc, [action || "Unknown"]: 0 }), {});
                }
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }
    }
    interactions.forEach((interaction) => {
        try {
            if (!interaction.InteractionStartDateUtc)
                return;
            const date = new Date(interaction.InteractionStartDateUtc);
            if (isNaN(date.getTime()))
                return;
            let key;
            switch (chartGranularity) {
                case "Hourly":
                    key = `${date.getMonth() + 1}/${date.getDate()} ${String(date.getHours()).padStart(2, "0")}:00`;
                    break;
                case "Daily":
                    key = `${date.getMonth() + 1}/${date.getDate()}`;
                    break;
                case "Weekly":
                    const weekStart = new Date(date);
                    weekStart.setDate(date.getDate() - date.getDay());
                    key = `${weekStart.getMonth() + 1}/${weekStart.getDate()}`;
                    break;
                default:
                    key = `${date.getMonth() + 1}/${date.getDate()}`;
            }
            if (key && key !== "NaN/NaN" && !key.includes("NaN")) {
                if (!groupedData[key]) {
                    groupedData[key] = actionTypes.reduce((acc, action) => ({ ...acc, [action || "Unknown"]: 0 }), {});
                }
                const action = normalizeInteractionFinalAction(interaction.InteractionFinalAction);
                const keyData = groupedData[key];
                if (keyData && keyData[action] !== undefined) {
                    keyData[action] = (keyData[action] || 0) + 1;
                }
                else if (keyData) {
                    keyData[action] = 1;
                }
            }
        }
        catch (error) {
            console.warn("Error processing interaction date:", error);
            return;
        }
    });
    let chartData = Object.entries(groupedData)
        .map(([period, actions]) => ({
        period: period || "Unknown",
        ...actions,
        total: Object.values(actions).reduce((sum, val) => sum + val, 0),
    }))
        .filter((item) => item.period && item.period !== "Unknown" && !item.period.includes("NaN"))
        .sort((a, b) => {
        if (chartGranularity === "Hourly") {
            const parseDateTime = (period) => {
                const [datePart, timePart] = period.split(" ");
                if (!datePart || !timePart)
                    return new Date();
                const [month, day] = datePart.split("/").map(Number);
                const hourStr = timePart.split(":")[0];
                if (!hourStr)
                    return new Date();
                const hour = parseInt(hourStr, 10);
                if (!month || !day || isNaN(hour))
                    return new Date();
                return new Date(new Date().getFullYear(), month - 1, day, hour);
            };
            return parseDateTime(a.period).getTime() - parseDateTime(b.period).getTime();
        }
        return a.period.localeCompare(b.period);
    });
    return chartData;
};
//# sourceMappingURL=chartUtils.js.map